import "../styles/main.scss"
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'

export const vuetify = createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#14CB88',
          secondary: '#224D61',
          white: '#FFFFFF',
          black: '#000000',
          textPrimary: '#191B1C',
          textSecondary: '#4E5153',
          backgroundPrimary: '#FFFFFF',
          backgroundSecondary: '#f8faf9',
          borderColor: '#191B1C1A',
          warning: '#FF9F2D',
          danger: '#ff1f5b',
        },
      },
    },
  },
})
